export default __webpack_public_path__ + "static/media/livro2.1ba23fd1.png";